import { API_ENDPOINTS } from "../../../rest/utils/api-endpoints";
import { HttpClient } from "../../../rest/utils/http";

export const postChangePassword = async (data: any) => {
  return await HttpClient.post(`${API_ENDPOINTS.CHANGE_PASSWORD}`, data);
};
